import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section id="comprar" className="py-24 px-4 bg-pastel-pink/30 text-center relative overflow-hidden scroll-mt-16" data-id="element-34">
      {/* Decorative */}
      <div className="absolute top-1/2 left-10 text-4xl animate-float opacity-60" data-id="element-35">
        🎈
      </div>
      <div className="absolute top-1/3 right-10 text-5xl animate-float-delayed opacity-60" data-id="element-36">
        ✨
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-37">
        <h2 className="text-4xl md:text-6xl font-bold text-brand-dark mb-6" data-id="element-38">
          ¿Lista para empezar esta aventura? 🚀
        </h2>

        <p className="text-xl md:text-2xl text-gray-700 mb-10 font-medium" data-id="element-39">
          No dejes pasar esta oportunidad. El desarrollo de tu hijo no espera.
        </p>

        <div className="bg-white p-8 rounded-3xl shadow-lg inline-block w-full md:w-auto" data-id="element-40">
          <p className="text-gray-500 line-through text-xl mb-1" data-id="element-41">
            Precio Normal: $47
          </p>
          <p className="text-brand-pink font-bold text-3xl mb-6" data-id="element-42">
            Hoy solo: $17
          </p>

          <CTAButton text="¡Quiero mi guía ahora por solo $17! 🚀" className="w-full text-lg md:text-xl" data-id="element-43" />

          <div className="mt-6 flex justify-center gap-2 text-gray-400 text-sm" data-id="element-44">
            <span data-id="element-45">🔒 Pago 100% Seguro</span>
            <span data-id="element-46">•</span>
            <span data-id="element-47">⚡ Acceso Inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}